import { Form } from '@unform/web';
import styled from 'styled-components';

export const HeaederForm = styled(Form)`
  display: flex;

  & > div {
    margin: 1.3em;
  }

  @media (max-width: 470px) {
    flex-flow: column;

    & > div {
      margin: 0.9em;
    }
  }
`;
